import cloneDeep from 'lodash/fp/cloneDeep';
import log from '../service/log';
import reviewsService from '../service/reviewsService';
import i18n from '../i18n';
import variants from '@/utils/enums/alertVariants';

const initialState = {
  csvResponse: false,
  isLoading: false,
  formattingError: false,
};

const getters = {};

const actions = {
  async submitCSV({ commit }, payload) {
    commit('SET_IS_LOADING', true);
    try {
      const res = await reviewsService.submitCSV(payload.department, payload.formData);
      if (res.data.errors) {
        commit('SET_FORMATTING_ERROR', true);
      } else {
        commit('SET_CSV_RESPONSE', res.data);
      }
    } catch (e) {
      commit(
        'SET_MESSAGE',
        { variant: variants.DANGER, message: { msg1: i18n.global.t('alerts.csvUploadError') } },
        { root: true }
      );
      log(e);
    } finally {
      commit('SET_IS_LOADING', false);
    }
  },
};

const mutations = {
  SET_CSV_RESPONSE(state, data) {
    state.csvResponse = data;
  },
  SET_IS_LOADING(state, data) {
    state.isLoading = data;
  },
  RESET_FORM_STATE(state) {
    state.csvResponse = false;
    state.formattingError = false;
  },
  SET_FORMATTING_ERROR(state, data) {
    state.formattingError = data;
  },
};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  getters,
  actions,
  mutations,
};
